import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import AssignmentForm from '../Assignments/AssignmentForm';

const ModalContent = styled.div`
  background: ${props => props.theme.cardBackground};
  border-radius: 8px;
  padding: 0;
  max-width: 500px;
  width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`;

const ModalHeader = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid ${props => props.theme.border};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h2`
  margin: 0;
  color: ${props => props.theme.text};
  font-size: 1.25rem;
  font-weight: 600;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.textSecondary};
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  font-size: 1.25rem;

  &:hover {
    background: ${props => props.theme.hoverBackground};
    color: ${props => props.theme.text};
  }
`;

const ModalBody = styled.div`
  padding: 1.5rem;
`;

const CalendarAssignmentEditModal = ({ isOpen, onClose, assignment, onSubmit }) => {
  const handleFormSubmit = () => {
    if (onSubmit) onSubmit();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        },
        content: {
          border: 'none',
          background: 'transparent',
          padding: 0,
          inset: 'auto',
        },
      }}
      ariaHideApp={false}
    >
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Edit Assignment</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        <ModalBody>
          <AssignmentForm
            assignment={assignment}
            onSubmit={handleFormSubmit}
            onCancel={onClose}
            isEditing={true}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CalendarAssignmentEditModal;